/**
 * Created by Anastasiya on 24.05.2024
 */

const UnitTrade = function () {
    this.selectedSource = undefined;
    this.selectedTarget = undefined;
    cleverapps.EventEmitter.call(this);
};

UnitTrade.prototype = Object.create(cleverapps.EventEmitter.prototype);
UnitTrade.prototype.constructor = UnitTrade;

UnitTrade.prototype.getSelected = function (type) {
    return type === UnitTrade.SOURCE ? this.selectedSource : this.selectedTarget;
};

UnitTrade.prototype.setSelected = function (type, selected) {
    const target = type === UnitTrade.SOURCE ? "selectedSource" : "selectedTarget";
    if (this[target] !== selected) {
        this[target] = selected;
        this.trigger("pickChange", type, selected);
    }

    cleverapps.tutorial.trigger("unit_trade_pick", type);
};

UnitTrade.prototype.getSourceTypes = function () {
    return ["clpet", "clpetrare"];
};

UnitTrade.prototype.getTargetTypes = function (sourceType) {
    switch (sourceType) {
        case "clpet":
            return ["clpetrare"];
        case "clpetrare":
            return ["clpetlegend"];
    }
};

UnitTrade.prototype.getTypeSubstitute = function (type) {
    switch (type) {
        case "clpetrare": case "clpetlegend":
            return [{ code: "clsimplechest", type, stage: type === "clpetlegend" ? 2 : 1 }];
    }
};

UnitTrade.prototype.getTradeUnitStage = function (tradeType, unitType) {
    if (tradeType === UnitTrade.SOURCE) {
        switch (unitType) {
            case "clpet":
                return 4;
            case "clpetrare":
                return 5;
        }
    }
    switch (unitType) {
        case "clpetrare": case "clpetlegend":
            return 2;
    }
};

UnitTrade.prototype.listTradeUnits = function (tradeType, unitType) {
    let tradeUnits = [];
    const targetStage = this.getTradeUnitStage(tradeType, unitType);

    if (tradeType === UnitTrade.SOURCE) {
        const mapUnits = {};
        const unitFilter = { type: unitType, stage: targetStage };
        Map2d.currentMap.listAvailableUnits(unitFilter).forEach((pet) => {
            if (mapUnits[pet.code]) {
                mapUnits[pet.code].amount++;
            } else {
                mapUnits[pet.code] = {
                    type: pet.getType(),
                    code: pet.code,
                    stage: pet.stage,
                    amount: 1
                };
            }
        });
        tradeUnits = Object.values(mapUnits);
    } else {
        tradeUnits = cleverapps.unitsLibrary.listAvailableByType(unitType).map((code) => ({ type: unitType, code, stage: targetStage }));
        if (tradeUnits.length === 0) {
            tradeUnits = this.getTypeSubstitute(unitType);
        }
    }
    return tradeUnits;
};

UnitTrade.prototype.exchange = function (callback) {
    const center = Map2d.currentMap.getScreenCenterCell();
    const sourceUnit = Map2d.currentMap.listAvailableUnits(this.selectedSource).sort((a, b) => cc.getDistanceChebyshev(a, center) - cc.getDistanceChebyshev(b, center))[0];
    let newUnit;

    new ActionPlayer([
        function (f) {
            Map2dScroller.currentScroller.zoomIn(sourceUnit, {
                zoom: 1.5,
                callback: f
            });
        },

        function (f) {
            Map2d.currentMap.highlightUnit(sourceUnit, f, { spotlight: true, ground: false });
        },

        function (f) {
            cleverapps.effects.fire("trade.window.exchange");

            sourceUnit.setPrizes();
            sourceUnit.onTradeSell(f);
        },

        function (f) {
            Map2d.currentMap.unhighlightUnit();
            sourceUnit.remove();

            newUnit = new Unit(this.selectedTarget);
            newUnit.setPosition(sourceUnit.x, sourceUnit.y);
            if (newUnit.findComponent(Feedable)) {
                newUnit.findComponent(Feedable).feedTime = Date.now();
            }
            Map2d.currentMap.onUnitAvailable(newUnit);
            Map2d.currentMap.onAddUnit(newUnit.x, newUnit.y, newUnit);

            Map2d.currentMap.highlightUnit(newUnit, () => {}, { spotlight: true, ground: false });
            newUnit.onTradeBuy(f);

            cleverapps.metrics.logEvent(cleverapps.EVENTS.TRADE_EXCHANGE + this.getRarityByType(newUnit.getType()));
        }.bind(this),

        function (f) {
            Map2dScroller.currentScroller.zoomOut();
            Map2d.currentMap.unhighlightUnit();
            f();
        }
    ]).play(callback);
};

UnitTrade.prototype.getRarityByType = function (unitType) {
    const rarity = {
        "clpet": "regular",
        "clpetrare": "rare",
        "clpetlegend": "legend"
    };
    return rarity[unitType];
};

UnitTrade.prototype.getIconByType = function (type) {
    return bundles.pet_tab_icons.frames[`tab_icon_${this.getRarityByType(type)}`];
};

UnitTrade.SOURCE = "source";
UnitTrade.TARGET = "target";